export const getAllCookies = () => {
	const cookies = document.cookie ? document.cookie.split('; ') : [];
	const allCookies = {};
	cookies.forEach((cookie) => {
		const [key, ...rest] = cookie.split('=');
		allCookies[key] = decodeURIComponent(rest.join('='));
	});
	return allCookies;
};
